import z from 'zod';

import { UnifiedCourierId } from 'common/api/api-types';

/**
 * Valid email address regular expression according to the HTML5 spec:
 * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 */
export const emailRegExp =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const legacyCourierId = z.string().regex(/^\d+$/);

export const parseCourierId = (raw?: string | null): UnifiedCourierId | undefined => {
  const digitsOnly = legacyCourierId.safeParse(raw);
  if (!digitsOnly.success) {
    return;
  }

  const courierId = UnifiedCourierId.safeParse(raw);
  if (!courierId.success) {
    return;
  }

  return courierId.data;
};

export const isFleetIncluded = (value: string): boolean =>
  value.toLocaleLowerCase().includes('fleet');
